import { useEffect, useState } from "react"
import { simpleGetter } from "../actions/common";
import { userApi } from "../api/api";

export const useSocialTranscriptScore = (userId: number | undefined): [number, any[]] => {
    const [score, setScore] = useState<number>(0);
    const [merits, setMerits] = useState<any[]>([])

    const fetchData = async () => {
        const response = await simpleGetter(userApi.getSocialTranscriptScore, userId)
        if (response.final_score) {
            setScore(response.final_score)
            setMerits(response.user_merits)
        }
    }

    useEffect(() => {
        if (userId) {
            setScore(0);
            setMerits([]);
            fetchData();
        }
    }, [userId])

    return [score, merits];
}